import type { RouterOutputs } from "@repo/api";
import type { ReactNode } from "react";
import { useEffect } from "react";
import { useShallow } from "zustand/react/shallow";

import { EmployeeGroupContext } from "~/hooks/use-employee-group";
import { api } from "~/lib/api";
import { useLoadingStore } from "~/stores/use-loading-store";
import { UnsavedChangesProvider } from "./unsaved-changes-provider";
import EmployeeGroupDialog from "~/components/employee-group/employee-group-dialog";

export type EmployeeGroup = RouterOutputs["employeeGroup"]["getAll"][number];
interface EmployeeGroupProviderProps {
  children: ReactNode;
}

export const EmployeeGroupProvider = ({
  children,
}: EmployeeGroupProviderProps) => {
  const { data: employeeGroups, isFetching: isEmployeeGroupsLoading } =
    api.employeeGroup.getAll.useQuery(undefined, {
      initialData: [],
    });

  const { setLoadingStage } = useLoadingStore(
    useShallow((state) => ({
      setLoadingStage: state.setCurrentLoadingStage,
    })),
  );

  useEffect(() => {
    if (isEmployeeGroupsLoading) {
      setLoadingStage("employeeGroups");
    } else {
      setLoadingStage(undefined);
    }
  }, [isEmployeeGroupsLoading, setLoadingStage]);

  const context = {
    employeeGroups,
  };

  return (
    <EmployeeGroupContext.Provider value={context}>
      {children}
      <UnsavedChangesProvider>
        <EmployeeGroupDialog />
      </UnsavedChangesProvider>
    </EmployeeGroupContext.Provider>
  );
};
